import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import VideoCard from '@/components/feature/VideoCard';
import { categories } from '@/mocks/homepage';
import { categoryVideos } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const videos = slug ? categoryVideos[slug] || [] : [];

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="pt-20 pb-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">分类不存在</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm">返回首页</Link>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  const categoryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 美女视频精选合集`,
    description: `${category.description}。高清美女视频在线免费观看，每日更新。`,
    url: `https://www.example.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '美女视频精选合集',
      url: 'https://www.example.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${category.name} - 美女视频精选合集`}
        description={`${category.description}。高清${category.name}视频在线免费观看，每日更新精选内容。`}
        keywords={`${category.name},美女视频,高清美女视频,美女视频在线观看`}
        canonicalUrl={`https://www.example.com/category/${slug}`}
        jsonLd={[categoryJsonLd]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="bg-background-100/70 border-b border-background-200/60">
            <div className="w-full px-4 md:px-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: category.name },
                ]}
              />
              <div className="pb-8 pt-2">
                <div className="flex items-center gap-4 mb-3">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${category.icon} text-xl`}></i>
                  </div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    {category.name}
                  </h1>
                </div>
                <p className="text-sm text-foreground-500 max-w-2xl">{category.description}</p>
              </div>
            </div>
          </div>

          <div className="w-full px-4 md:px-6 py-3 bg-background-50 border-b border-background-200/40 overflow-x-auto">
            <div className="flex items-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="w-full px-4 md:px-6 py-10">
            <div className="flex items-center justify-between mb-6">
              <p className="text-sm text-foreground-500">
                共 <strong className="text-foreground-900">{videos.length}</strong> 个视频
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {videos.map((video) => (
                <VideoCard
                  key={video.id}
                  id={video.id}
                  title={video.title}
                  category={category.name}
                  categorySlug={category.slug}
                  imageUrl={video.imageUrl}
                  duration={video.duration}
                  views={video.views}
                  date={video.date}
                  isHot={video.isHot}
                  isNew={video.isNew}
                />
              ))}
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}